import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store.js';
import App from './App.vue';
import JQuery from 'jquery';
import Meta from 'vue-meta';
import VueScrollactive from 'vue-scrollactive';
window.$ = JQuery.$ = JQuery;
import 'popper.js';
import 'bootstrap';
import '../node_modules/bootstrap/scss/bootstrap.scss';
import '../node_modules/pretty-checkbox/src/pretty-checkbox.scss';
import '../node_modules/slick-carousel/slick/slick.css';
import './styles/app.scss';
import vSelect from 'vue-select';
import VueScrollTo from 'vue-scrollto';
import posthog from 'posthog-js'

import { sync } from 'vuex-router-sync';
sync(store, router);

import router from './routes.js';

import '../node_modules/animate.css/animate.css';
import '../node_modules/vue-select/src/scss/vue-select.scss';

import AOS from 'aos';
import 'aos/dist/aos.css';

import VueSweetAlert from 'vue-sweetalert'

Vue.component('v-select', vSelect);
Vue.use(Meta);

Vue.use(VueSweetAlert);
Vue.use(VueScrollTo);
Vue.use(VueRouter);
Vue.use(VueScrollTo);
Vue.use(VueScrollactive);
Vue.use(Meta);
Vue.use(VueScrollTo);
export const APP_ID = "nsungu8r"

// Loads Intercom with the snippet
// This must be run before boot, it initializes window.Intercom
// prettier-ignore
export const loadIntercom = () => {
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
}

// Initializes Intercom
export const bootIntercom = (options = {}) => {
  window &&
  window.Intercom &&
  window.Intercom("boot", { app_id: APP_ID, ...options })
}

export const updateIntercom = () => {
  window && window.Intercom && window.Intercom("update")
}

Vue.config.productionTip = false;

new Vue({
  created () {
    AOS.init()
    posthog.init('phc_9rjMwNSJTLjYVtrohBbH6ZwHEVBWwVdVdbtPj4uQSUX', { api_host: 'https://app.posthog.com' })
  },
  render: h => h(App),
  router,
  store,
}).$mount('#app');

loadIntercom();
bootIntercom();

router.afterEach(( to, from ) => {
  updateIntercom();
});
